if (!customElements.get('zoom-images')) {
  customElements.define(
    'zoom-images',
    class ZoomImages extends HTMLElement {
      constructor() {
        super();

        this.mediaContainer = this.closest('[data-product-single-media-group]');
        this.slider = this.mediaContainer?.querySelector('[data-product-single-media-slider]');
        this.zoomWrappers = this.mediaContainer?.querySelectorAll('[data-zoom-wrapper]');
        this.a11y = window.theme.a11y;
      }

      connectedCallback() {
        if (this.zoomWrappers.length) {
          this.zoomWrappers.forEach((element, i) => {
            element.addEventListener('click', (e) => {
              e.preventDefault();

              const isMoving = this.slider && this.slider.classList.contains('is-moving');

              if (!isMoving) {
                this.a11y.state.trigger = element;
                this.createZoom(i);
              }
            });
          });
        }
      }

      createZoom(indexImage) {
        const instance = this;
        let items = [];
        let counter = 0;

        this.zoomWrappers.forEach((elementImage) => {
          const imgSrc = elementImage.getAttribute('href');
          const imgWidth = parseInt(elementImage.getAttribute('data-image-width'));
          const imgHeight = parseInt(elementImage.getAttribute('data-image-height'));

          items.push({
            src: imgSrc,
            w: imgWidth,
            h: imgHeight,
            msrc: imgSrc,
          });

          counter += 1;
          if (instance.zoomWrappers.length === counter) {
            let popupClass = 'pswp-zoom-gallery';

            if (counter === 1) {
              popupClass = 'pswp-zoom-gallery pswp-zoom-gallery--single';
            }
            const options = {
              barsSize: {top: 60, bottom: 60},
              history: false,
              focus: false,
              index: indexImage,
              mainClass: popupClass,
              showHideOpacity: true,
              showAnimationDuration: 250,
              hideAnimationDuration: 250,
              closeOnScroll: false,
              closeOnVerticalDrag: false,
              captionEl: false,
              closeEl: true,
              closeElClasses: ['caption-close'],
              tapToClose: false,
              clickToCloseNonZoomable: false,
              maxSpreadZoom: 2,
              loop: true,
              spacing: 0,
              allowPanToNext: true,
              pinchToClose: false,
            };

            new window.theme.LoadPhotoswipe(items, options);
          }
        });
      }
    }
  );
}
